module.exports = __webpack_public_path__ + "static/media/accepted_pass.ee6ca56b.svg";